import { ReactNode, createContext } from 'react';
import { CardTemplate } from '@shared/scenes/cards/types';

interface CardTemplateContextType {
  template?: CardTemplate;
}

export const CardTemplateContext = createContext<CardTemplateContextType>({ template: undefined });

interface Props {
  template: CardTemplate;
  children: ReactNode;
}

export function MBCardTemplateProvider({ template, children }: Props) {
  return (
    <CardTemplateContext.Provider value={{ template }}>{children}</CardTemplateContext.Provider>
  );
}
